import PropTypes from "prop-types";
import React, { useState } from 'react';
import "../../style/AlbumDetail.css"

const AlbumDetail=({
    album,
    group,
    draggable = false,
    correction = null,
    showTitle = false,
    showGroup = false,
    showCorrectionOnFlip = false,
    className = "",
    onClick = () => { }
})=> {
    // const headingId = `album-title-${album.id}`; // Unique ID pour le titre de l'œuvre
    // const buttonId = `album-button-${album.id}`; // Unique ID pour le bouton d'action
    const [flipImage, setFlipImage] = useState(false);


    if (!album) return "";
    const handleClick = () => {
        onClick();
        if (showCorrectionOnFlip) {
            setFlipImage(prev => !prev);
        }
    }
    return (
        <button title={showCorrectionOnFlip?`Montrer plus d'informations`:""} type="button" draggable={draggable} className={`albumDetail_box ${showCorrectionOnFlip?'flippable':''} ${flipImage? `flipped` : `` } ${className} ${correction!==null?(correction?`correct`:`incorrect`):``}`} onClick={handleClick} >
            <div className="albumDetail_front">
                <img className="albumDetail_image" src={`${import.meta.env.BASE_URL}${album.imageUrl}`} alt=""/>
                <div className="albumDetail_info">
                    <p className={`albumDetail_title ${!showTitle && `hidden`}`}>
                        {album?.albumTitle?.length > 40 
                        ? `${album?.albumTitle.slice(0, 40)}…` 
                        : album?.albumTitle}
                    </p>
                    <p className="albumDetail_separator">-</p>
                    <p className={`albumDetail_group ${!showGroup && `hidden`}`}>{group?.name}</p>
                </div>
            </div>
            {showCorrectionOnFlip ?
                <div className="albumDetail_back">
                    <img className="albumDetail_image" src={`${import.meta.env.BASE_URL}${album.imageUrl}`} alt=""/>
                    <div className="albumDetail_info">
                        <p className="albumDetail_date">{`Sortie : ${album.fullDate}`}</p>
                    </div>
                </div>
                : null
            }
        </button>
    );
}

AlbumDetail.propTypes = {
    album: PropTypes.shape({
        imageUrl: PropTypes.string.isRequired,
        albumTitle: PropTypes.string.isRequired,
        groupId: PropTypes.string.isRequired,
        dateAlbum: PropTypes.string.isRequired,
    }).isRequired,
    group: PropTypes.shape({
        imageUrl: PropTypes.string.isRequired,
        albumTitle: PropTypes.string.isRequired,
        groupId: PropTypes.string.isRequired,
        dateAlbum: PropTypes.string.isRequired,
    }).isRequired,
    showTitle: PropTypes.bool,
    showGroup: PropTypes.bool,
    showCorrectionOnFlip: PropTypes.bool,
    onClick: PropTypes.func,
};

export default AlbumDetail;